import { useState, FC } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { useTranslation } from "react-i18next";
import { AccessPointGridPluginSettings } from "./AccessPointGridPluginSettings";
import { AccessPointGrid } from "./AccessPointGrid";

const AccessPointSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const gridId = uuidv4();
    const plugin = AccessPointGridPluginSettings
    const { t } = useTranslation();
    
    return (
        <GridSelectorModalWindow
            entityToPressEnter={entity}
            gridDisplayName={plugin?.name ?? t('directory.accessPoint.title')}
            ok={{
                onClick: () => props.ok?.(entity)
            }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            {
                plugin ? 
                    <AccessPointGrid 
                        gridId={gridId} 
                        plugin={plugin}
                        baseGridFilter={props.gridFilter}
                        onSelect={(row) => row && setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.displayName })
                            props.ok?.(entity)
                        }}
                    />
                    : 
                    <p> {t('general.directoryNotConfigured')} </p>
            }
        </GridSelectorModalWindow>
    )
}

export default AccessPointSelectorModal